import { productListExpanded } from "components/Stacker/actions/StackerActions"
import PropTypes from "prop-types"
import "./AmuletProductListHeader.scss"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"
import { i18n, i18nString, loadedLocales } from "i18n/i18n-util"
import { useEffect } from "react"
import { loadLocaleAsync } from "i18n/i18n-util.async"

export default function AmuletProductListHeader({
  expanded,
  selectedProductsAmt,
  maxItems,
}) {
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const onExpandClick = () => {
    dispatch(productListExpanded(!expanded))
  }

  // useEffect(() => {
  //   const setFr = async () => {
  //     await loadLocaleAsync("fr")
  //     setLocale("fr")
  //   }
  //   setFr()
  // }, [])

  return (
    <div className="list-header position-relative mb-0 mb-xl-2 mb-lg-0 text-uppercase">
      <div className="list-header-description w-100 text-black">
        {LL.amulets.amuletGridHeadline(selectedProductsAmt, maxItems.large)}
      </div>
      <div className="list-header-button-right d-block d-lg-none">
        <button className="btn btn-text text-uppercase" onClick={onExpandClick}>
          {!expanded ? (
            <>
              {LL.amulets.expand()}{" "}
              <img
                className="align-baseline"
                src={`${AEM_ASSETS}/temp/icon-chevron-up.svg`}
                alt="Expand"
              />
            </>
          ) : (
            <>
              Collapse{" "}
              <img
                className="align-baseline"
                src={`${AEM_ASSETS}/temp/icon-chevron-down.svg`}
                alt="Collapse"
              />
            </>
          )}
        </button>
      </div>
    </div>
  )
}

AmuletProductListHeader.propTypes = {
  expanded: PropTypes.bool,
  maxItems: PropTypes.object.isRequired,
  selectedProductsAmt: PropTypes.number.isRequired,
}
